import { Fragment } from 'react';
import { TermContentText, TermContentTextBold } from '../../TermsModal/styles';

export const FullTrialTerm = () => {
  return (
    <Fragment>
      <TermContentText>
        1. Upon the Client’s payment of the Search Fee, the Company shall
        provide the Client with one (1) trial (of minimum three (3) hours
        duration) during which the Client may access the Service with the Sitter
        (“<TermContentTextBold>Trial</TermContentTextBold>”). The Company shall
        inform the parent within seven (7) business days once the Sitter is
        found upon. The Sitter Profile shall be provided at our discretion.
      </TermContentText>
      <TermContentText>
        2. The Trial must be utilised seven (7) business days upon informing the
        Client of the details of the Sitter allocated from the Company’s receipt
        of the Search Fee.
      </TermContentText>
      <TermContentText>
        3. If after the Trial the Client is not satisfied with the relevant
        Sitter, the Client may by no later than one (1) week after the Trial,
        request the Company allocate another Sitter, and arrange another Trial.
        If after the <TermContentTextBold>second Trial</TermContentTextBold> the
        Client is still not satisfied, this Agreement shall terminate although
        the Client shall remain liable to pay any amounts due and owing as set
        out in the Schedule. For the avoidance of doubt, the Client shall only
        be entitled to a maximum of two (2) Trials and may only request an
        alternative Sitter once. In the event that midterm the Client wants to
        change Sitter, both parties’ contract will terminate at one month’s
        notice.
      </TermContentText>
      <TermContentText>
        4. After the trial session with the Sitter, the Client has 7 calendar
        days to decide if they would like to continue with the Sitter's services
        on an ongoing basis. If the Client does not confirm their decision
        within this 7 day period, the Sitter may be made available for other
        opportunities. Any continued availability of the babysitter after this
        period cannot be guaranteed.
      </TermContentText>
    </Fragment>
  );
};

export default FullTrialTerm;
